import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input } from '@angular/core';
import { AbstractControl, ControlValueAccessor, FormArray, FormGroup } from '@angular/forms';

import { planGroupConfig, planKeys, TPlanKeys } from '@assess/shared/entities';

@Component({
  selector: 'assess-plan-group',
  templateUrl: './plan-group.component.html',
  styleUrls: ['./plan-group.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PlanGroupComponent implements ControlValueAccessor {
  maxLength = 500;
  @Input() disabled = false;
  @Input() required = false;
  @Input() formArray!: FormGroup;
  form!: FormGroup;
  labels: Record<TPlanKeys, string> = planGroupConfig.labels;
  placeholders: Record<TPlanKeys, string> = planGroupConfig.placeholders;
  planKeys = planKeys;
  _value: any = {};

  constructor(private readonly changeDetectorRef: ChangeDetectorRef) {}

  public get invalid(): boolean {
    return this.formArray ? this.formArray.invalid ?? false : false;
  }

  get disable() {
    return this.formArray?.disabled;
  }

  onCheckboxChange(checked: boolean, group: AbstractControl) {
    if (!checked && group) {
      group.get('text')?.setValue('');
    } else {
      group.get('text')?.enable();
    }
  }

  getError(group: AbstractControl, controlName: string) {
    const error = group?.get(controlName)?.errors?.[controlName];

    return error;
  }

  getPlaceHolder(plan: string) {
    return this.placeholders[plan as TPlanKeys];
  }

  getLabel(plan: string) {
    return this.labels[plan as TPlanKeys];
  }

  getFormArray() {
    return this.formArray as unknown as FormArray;
  }

  isChecked(group: AbstractControl) {
    return group?.get('checked')?.value || false;
  }

  saveAndPropagate(value: PlanGroupComponent['_value']) {
    this.onChange(value);
    this.onTouched();
  }

  onChange = (_: any) => {
    /* nothing */
  };

  onTouched = () => {
    /* nothing */
  };

  setDisabledState(isDisabled: boolean) {
    this.disabled = isDisabled;
    this.changeDetectorRef.markForCheck();
  }

  registerOnChange(fn: PlanGroupComponent['onChange']) {
    this.onChange = fn;
  }

  registerOnTouched(fn: PlanGroupComponent['onTouched']) {
    this.onTouched = fn;
  }

  writeValue(): void {
    this.changeDetectorRef.markForCheck();
  }
}
